<template>
    <div class="price-page">
        <!-- 价格列表区域 -->
        <!-- 修改为使用 el-table-column 的 Table 组件 -->
        <el-table :data="tableData" border stripe :row-style="rowStyle">
            <el-table-column prop="treatment" label="治疗项目">
                <!-- 使用列插槽显示数据 -->
                <template #default="{ row }">
                    <span :style="{ 
                        fontWeight: shouldBold(row.treatment)? 'bold' : 'normal',
                        color: shouldChangeColor(row.treatment)? '#2e7d32' : 'inherit',
                        fontSize: row.treatment === 'GRUNDPRISER:'? 'calc(1em + 4px)' : '1em',
                        color: row.treatment === 'GRUNDPRISER:'? 'black' : 'inherit',
                        fontWeight: row.treatment === 'GRUNDPRISER:'? 'bold' : 'normal'
                    }">
                        {{ row.treatment }}
                    </span>
                    <!-- 移除原有的分隔线和标题逻辑 -->
                </template>
            </el-table-column>
            <el-table-column prop="price" label="价格">
                <template #default="{ row }">
                    <!-- 添加样式判断 -->
                    <span :style="{ 
                        fontWeight: row.price === 'price:' && row.treatment === 'TDP & Scrape therapy(30mins):'? 'bold' : 'normal',
                        color: row.price === 'price:' && row.treatment === 'TDP & Scrape therapy(30mins):'? '#2e7d32' : 'inherit' 
                    }">
                        {{ row.price }}
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <!-- 说明与图标区域 -->
        <div class="notice-section">
            <img src="@/assets/heart.jpg" style="padding-right: 15px;"/>
            <span>Pensionärer och barn (under 18 år) ges 10 % rabatt. ( Gäller endast grundpriser)</span>
        </div>
        <!-- 按钮区域 -->
        <div class="button-section">
            <!-- 修改为 Element UI 的 Button 组件 -->
            <el-button type="primary" class="book-button" @click="toLink">BOKA TID</el-button>
        </div>
        <!-- 注意事项区域 -->
        <div class="bottom-notice">
            <p>Du kan av- eller boka din tid fram till 24 timmar innan ditt besök och det måste ske på vardagar. Då hinner vi erbjuda tiden till någon annan. Detta gör du genom att meddela oss via telefon samtal eller SMS på 070 - 4281756. Vid försena avbokning...</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "PricePage",
    data() {
        return {
            columns: [
                {
                    title: '治疗项目',
                    key: 'treatment'
                },
                {
                    title: '价格',
                    key: 'price'
                }
            ],
            tableData: [
                {
                    treatment: 'Akupunktur nybesök inkl diagnos(65min):',
                    price: '800 kr'
                },
                {
                    treatment: 'Akupunktur nybesök inkl diagnos(65min):',
                    price: '800 kr'
                },
                {
                    treatment: 'Kombinationsbehandling: TCM - Akupunktur kombinerat med (+ev. moxi & koppning & scrape etc & TDP Värmelampa)(50min)',
                    price: '640 kr'
                },
                {
                    treatment: 'Vid fler än 5 kombinationsbehandlingar ges 5 % rabatt per behandling',
                    price: '3040 kr'
                },
                {
                    treatment: 'Vid fler än 10 kombinationsbehandlingar ges 10 % rabatt per behandling',
                    price: '5760 kr'
                },
                // 新增空行
                {
                    treatment: 'GRUNDPRISER:',
                    price: ''
                },
                {
                    treatment: 'Akupunktur: 30 minuter behandling:',
                    price: '480kr'
                },
                {
                    treatment: '10× behandling (kostar):',
                    price: '4400kr'
                },
                {
                    treatment: '60 minuter behandling:',
                    price: '600kr'
                },
                {
                    treatment: '10× behandling (kostar):',
                    price: '5200kr'
                },
                {
                    treatment: 'Moxibustion(30mins):',
                    price: 'price:'
                },
                {
                    treatment: 'Genomgång och diagnos:',
                    price: '450kr'
                },
                {
                    treatment: '5× behandling (kostar):',
                    price: '2100kr'
                },
                {
                    treatment: '10× behandling (kostar):',
                    price: '4050kr'
                },
                {
                    treatment: 'TDP & Scrape therapy(30mins):',
                    price: 'price:'
                },
                {
                    treatment: 'Genomgång och diagnos:',
                    price: '500kr'
                },
                {
                    treatment: '5× behandling (kostar):',
                    price: '2300kr'
                },
                {
                    treatment: '10× behandling (kostar):',
                    price: '4300kr'
                },
                {
                    treatment: 'Akupunktur & Koppning(30 mins):',
                    price: 'price:'
                },
                {
                    treatment: 'Genomgång och diagnos:',
                    price: '500kr'
                },
                {
                    treatment: '5× behandling (kostar):',
                    price: '2300kr'
                },
                {
                    treatment: '10× behandling (kostar):',
                    price: '4300kr'
                },
                {
                    treatment: 'TDP Fysiotherapilampa(30 mins):',
                    price: '150kr'
                },
                {
                    treatment: 'Öronakupunktur och diagnos:',
                    price: '350kr'
                },
                {
                    treatment: 'TCM(Traditionell Kinesisk Medicin) Diagnos:',
                    price: '300kr Varje gång'
                }
            ]
        };
    },
    methods: {
        shouldBold(treatment) {
            return ['Moxibustion(30mins):', 'TDP & Scrape therapy(30mins):', 'Akupunktur & Koppning(30 mins):', 'Akupunktur'].some(keyword => treatment.includes(keyword));
        },
        shouldChangeColor(treatment) {
            return ['Moxibustion(30mins):', 'TDP & Scrape therapy(30mins):', 'Akupunktur & Koppning(30 mins):', 'Akupunktur'].some(keyword => treatment.includes(keyword));
        },
        rowStyle({ row }) {
            const specialTreatments = ['TDP & Scrape therapy(30mins):', 'Moxibustion(30mins):', 'Akupunktur & Koppning(30 mins):'];
            if (specialTreatments.includes(row.treatment)) {
                return {
                    backgroundColor: '#e8f5e9',
                    fontWeight: 'bold',
                    fontSize: '1.2em'
                };
            }
            // 修改背景颜色为 #e91e63
            if (row.treatment === 'GRUNDPRISER:') {
                return {
                    backgroundColor: '#e91e63'
                };
            }
            return {};
        },
        toLink() {
            window.open('https://yghealthab.simplybook.it/v2/', '_blank');
        }
    }
};
</script>

<style lang="scss">
.price-page {
    min-width: 1200px; 
    width: 1200px; 
    font-family: Arial, sans-serif;
    padding: 20px;
}

.separator {
    border-top: 1px dotted #ccc;
    margin: 20px 0;
}

.sub-title {
    font-weight: bold;
    margin-bottom: 10px;
}

.notice-section {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    margin-top: 20px;
}

.notice-section .icon {
    width: 30px;
    height: 30px;
    margin-right: 10px;
}

.button-section {
    text-align: center;
    margin-bottom: 20px;
}

.button-section .book-button {
    padding: 10px 20px;
    font-size: 16px;
}

.bottom-notice {
    color: purple;
    font-size: 14px;
}
</style>
